import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';

import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import Games from './pages/Games';
import Categories from './pages/Categories';
import PuzzleItems from './pages/PuzzleItems';
import ImageLibraryPage from './pages/ImageLibraryPage';
import SettingsPage from './pages/SettingsPage';

export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        {
          element: <Navigate to='/dashboard/games' />,
          index: true,
        },
        { path: 'games', element: <Games /> },
        { path: 'categories', element: <Categories /> },
        { path: 'puzzle-items', element: <PuzzleItems /> },
        { path: 'image-library', element: <ImageLibraryPage /> },
        { path: 'sports', element: <SettingsPage /> },
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to='/dashboard' />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to='/404' /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to='/404' replace />,
    },
  ]);

  return routes;
}
